


import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import CalendarPage from './pages/CalendarPage';
import TasksPage from './pages/TasksPage';
import ClassesPage from './pages/ClassesPage';
import EllipsusLanding from './pages/EllipsusLanding';
import Navigation from './components/Navigation';

function App() {
  return (
    
      <div>
        <div>
          <Navigation/>
        </div>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/task" element={<TasksPage />} />
          <Route path="/classes" element={<ClassesPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </div>
    
  );
}

export default App;









